export default __webpack_public_path__ + "static/media/cross_home.1aaff478.svg";